module.exports = __webpack_public_path__ + "static/blog-rocket-b2b73f7b1d845f1af3132bf2f19154e7.svg";